export interface BookingPaymentTerminology {
    readonly label: string
    readonly lowercaseLabel: string
    readonly actionLabel: string
    readonly actionPhrase: string
}

const DEFAULT_TERMINOLOGY: BookingPaymentTerminology = {
    label: 'Deposit',
    lowercaseLabel: 'deposit',
    actionLabel: 'Pay Deposit',
    actionPhrase: 'pay your deposit',
}

const GENERIC_PAYMENT_TERMINOLOGY: BookingPaymentTerminology = {
    label: 'Payment',
    lowercaseLabel: 'payment',
    actionLabel: 'Make Payment',
    actionPhrase: 'make your payment',
}

const GENERIC_PAYMENT_VENUE_IDS = new Set([
    '6f7ca398-0f78-4d8b-a4e1-88cf4d443bb4', // Paddock
    '5a0585fe-be28-40d2-83f7-8a5f2b993a50', // Law Golf and Things Local
    '6ddf7b8a-86ce-4ca6-aeb9-332b8bc2e263', // Golf and Things Staging
    '4a315b73-ad25-44c2-a21b-1d94b100c1c4', // Safari & Co
])

export function bookingPaymentTerminologyForVenueId(
    venueId?: string | null,
    isPaidUpsell = false
): BookingPaymentTerminology {
    return usesGenericPaymentTerminology(venueId, isPaidUpsell)
        ? GENERIC_PAYMENT_TERMINOLOGY
        : DEFAULT_TERMINOLOGY
}

export function usesGenericPaymentTerminology(
    venueId?: string | null,
    isPaidOrder = false
): boolean {
    return isPaidOrder || (!!venueId && GENERIC_PAYMENT_VENUE_IDS.has(venueId))
}
